export type EmbeddedCredentialMode = 'token' | 'cookie'

export type EmbeddedCredential = {
  mode: EmbeddedCredentialMode
  value: string
}

let isEmbedded = false
let credential: EmbeddedCredential | null = null

export const markEmbeddedRuntime = (): void => {
  isEmbedded = true
}

export const isEmbeddedRuntime = (): boolean => isEmbedded

export const setEmbeddedCredential = (next: EmbeddedCredential): void => {
  credential = next
}

export const getEmbeddedCredential = (): EmbeddedCredential | null => credential

export const clearEmbeddedCredential = (): void => {
  credential = null
}

export const getEmbeddedSessionToken = (): string | null =>
  credential?.mode === 'token' ? credential.value : null
